<template>
  <section
    id="facelift"
    class="hide-overflow"
  >
    <v-container mt-3>
      <v-layout>
        <v-flex>
          <h1>Simoni Facelift</h1>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
export default {
  data: () => ({
  })
}
</script>
